<template>
  <div class="flex flex-col">
    <div class="relative flex flex-col bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest">
      <div class="flex relative flex-col pt-1 flex-no-shrink flex-no-grow w-1/2 z-10">
          <div class="flex flex-row h-12 text-xs items-center">
            <div v-if="role !== 'specialistDoctor'" @click="selectTab('requested')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'requested' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']" style="padding: 10px 0px 10px 0px;">
              Requested
            </div>
            <div @click="selectTab('scheduled')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'scheduled' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']" style="padding: 10px 0px 10px 0px;">
              Scheduled
            </div>
            <div @click="selectTab('completed')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'completed' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']" style="padding: 10px 0px 10px 0px;">
              Completed
            </div>
            <div v-if="!['specialistDoctor', 'externalAdmin'].includes(role)" @click="selectTab('no_response')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'no_response' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']" style="padding: 10px 0px 10px 0px;">
              1 Failed Attempt
            </div>
            <div v-if="['specialistDoctor', 'externalAdmin'].includes(role)" @click="selectTab('received')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'received' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']" style="padding: 10px 0px 10px 0px;">
              Received
            </div>
            <div @click="selectTab('incomplete')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'incomplete' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']" style="padding: 10px 0px 10px 0px;">
              Incomplete
            </div>
            <div v-if="!['specialistDoctor', 'externalAdmin'].includes(role)" @click="selectTab('rejected')" class="w-1/3 text-center cursor-pointer" v-bind:class="[activeTab === 'rejected' ? 'font-semibold' : 'font-light text-grey hover:text-blue hover:font-semibold']">
              Rejected
            </div>
          </div>
          <div class="flex flex-row h-1 bg-grey-lightest">
            <div v-if="role !== 'specialistDoctor'" class="w-1/3" v-bind:class="[activeTab === 'requested' ? 'bg-blue' : '']"></div>
            <div class="w-1/3" v-bind:class="[activeTab === 'scheduled' ? 'bg-blue' : '']"></div>
            <div class="w-1/3" v-bind:class="[activeTab === 'completed' ? 'bg-blue' : '']"></div>
            <div v-if="!['specialistDoctor', 'externalAdmin'].includes(role)" class="w-1/3" v-bind:class="[activeTab === 'no_response' ? 'bg-blue' : '']"></div>
            <div v-if="['specialistDoctor', 'externalAdmin'].includes(role)" class="w-1/3" v-bind:class="[activeTab === 'received' ? 'bg-blue' : '']"></div>
            <div class="w-1/3" v-bind:class="[activeTab === 'incomplete' ? 'bg-blue' : '']"></div>
            <div v-if="!['specialistDoctor', 'externalAdmin'].includes(role)" class="w-1/3" v-bind:class="[activeTab === 'rejected' ? 'bg-blue' : '']"></div>
          </div>
      </div>
      <div class="absolute h-12 mt-2 border-solid border-b-4 border-grey-lightest w-full z-0"> </div>
      <div class="flex flex-col overflow-y-scroll" v-if="role !== 'externalAdmin' && activeTab === 'requested'" style="height: calc(100vh - 6rem);">
        <requested-appointment-table />
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="role === 'externalAdmin' && activeTab === 'requested'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="6" :data="data" :canReschedule=true @updateAptRequest="updateAptRequest" @updateStatus="updateStatus" @updateRemark="updateRemark" @startConsultation="startConsultation"/>
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="activeTab === 'scheduled'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="0" :data="data" :canReschedule=true @updateAptRequest="updateAptRequest" @updateStatus="updateStatus" @updateRemark="updateRemark" @startConsultation="startConsultation"/>
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="activeTab === 'completed'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="1" :data="data" @updateStatus="updateStatus" @updateRemark="updateRemark" @uploadDocuments='uploadDocuments'/>
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="activeTab === 'no_response'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="2" :data="data" @updateStatus="updateStatus" @updateRemark="updateRemark" @startConsultation="startConsultation"/>
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="activeTab === 'incomplete'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="3" :data="data" @updateStatus="updateStatus" @updateRemark="updateRemark"/>
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="activeTab === 'rejected'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="4" :data="data" @updateStatus="updateStatus" @updateRemark="updateRemark"/>
      </div>
      <div class="flex flex-col overflow-y-scroll" v-if="activeTab === 'received'" style="height: calc(100vh - 6rem);">
        <appointment-table :tab="5" :data="data" @updateStatus="updateStatus" @updateRemark="updateRemark"/>
      </div>
    </div>


    <!-- Assign doctor modal start from here -->
    <div v-if="showModal">
      <div id="overlay" @click='closeModal()' style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 100; cursor: pointer;"></div>
      <div class="absolute flex flex-col bg-white shadow rounded-lg"  style="width: 600px; left: calc((100vw - 600px)/2); top:80px; height: 420px; z-index: 110">
        <div class="text-grey-darker px-5 py-4 text-lg font-semibold">Assign doctor</div>
        <img @click='closeModal()' src='../../assets/Cross.svg' class="mr-4 mt-2 cursor-pointer absolute" style="right: 10px; top: 10px; height: 20px; width: 20px;">
        <!--Doctor list-->
        <div v-if="true" class="flex flex-col bg-white px-5 py-2 mt-2">
          <div class="flex justify-end relative">
            <input v-model="selectedDoctor" @input="searchDoctors" @click="toggleDropdown" class="w-full p-3 cursor-pointer capitalize relative bg-grey-extralight rounded-m border border-solid border-grey-lightest 
            text-base text-grey-dark font-semibold placeholder-icon" type="search" placeholder="   Search for Doctors"/>
            <img v-if="showOptions" @click='toggleDropdown()' src='../../assets/dropdown_UpArrow.svg' class="flex absolute cursor-pointer self-center pr-2">
            <img v-else @click='toggleDropdown()' src='../../assets/dropdown_DownArrow.svg' class="flex absolute cursor-pointer self-center pr-2">
          </div>
          <div v-if="showOptions" class="mt-1 rounded-lg border-grey-lightest border py-1" >
            <div v-if="doctorsList.length === 0">
              <span class="text-sm flex justify-center my-2 text-red-light">Search result not found</span>
            </div>
            <div v-else class='flex flex-col'>
              <span class="text-xs text-grey-lighter tracking-wide font-semibold flex justify-center my-2 ml-3 self-start ">AVAILABLE DOCTORS</span>
              <div class="flex flex-col scrollbar-hide overflow-y-auto" style="max-height: 176px;">
                <div v-for="(doctor, index) in doctorsList" :key="index" @click="selectDoctor(doctor)" 
                  :class="{doctorActive : (doctor.name === selectedDoctor)}" 
                  class="flex flex-col h-12 pl-3 pr-3 justify-center pt-3 flex-no-shrink flex-no-grow cursor-pointer hover:bg-grey-extralight">
                  <div class="flex flex-row align-middle mb-2 items-center">
                    <img v-if="doctor.name === selectedDoctor" class="pr-2" src='../../assets/radio_selected.svg' alt="doctor">
                    <img v-else class="pr-2" src='../../assets/radio_unselected.svg' alt="doctor">
                    <div class="text-sm text-grey-dark font-semibold self-center capitalize">{{doctor.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Slots listing -->
        <div v-if="showSlots && !showOptions && doctorsList.length>0 && selectedDoctor" class="flex flex-col bg-white px-5 py-2">
          <span class="text-xs text-grey-lighter tracking-widest font-semibold flex justify-center my-2 self-start ">AVAILABLE SLOTS</span>
          <div class="flex flex-wrap scrollbar-hide overflow-y-auto" style="max-height: 176px;">
            <div @click='slot.available ? selectSlot(slot) : ()=>{}' class="text-sm cursor-pointer font-semibold rounded-full flex-no-shrink flex-no-grow text-center px-4 py-3 my-2 mr-4 " v-for="(slot,i) in slotsList" :key="i" v-bind:class="[slot.slot === selectedSlot.slot ? 'text-white bg-blue' : slot.available ? 'text-grey border border-solid border-grey-lightest bg-grey-extralight' : 'text-grey-lighter border border-solid border-grey-extralight bg-white cursor-not-allowed']">
              {{slot.slot}}
            </div>
          </div>
        </div>
        <!--Add new doctor-->
        <div class="absolute bg-white flex content-center font-semibold justify-center px-5 py-4 mb-2 w-full pin-b ">
          <div @click='assignDoctorHandler()' class="ml-4 px-4 py-3 rounded text-sm hover:shadow-md" v-bind:class="[this.selectedDoctor && this.selectedSlot ?  'cursor-pointer text-white bg-blue' : 'cursor-not-allowed text-white bg-grey-lightest']">Assign Doctor</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppointmentTable from '@/components/Appointments/AppointmentTable'
import RequestedAppointmentTable from '@/components/Appointments/RequestedAppointmentTable'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
import appointments from '../../api/appointments'
import {mapGetters} from 'vuex'
Vue.use(VueToast)

export default {
  components: {
    AppointmentTable,
    RequestedAppointmentTable
  },
  name: 'Appointments',
  data () {
    return {
      data: {},
      showOptions: false,
      showSlots: false,
      selectedDoctor: '',
      selectDoctorId: null,
      selectedSlot: '',
      doctorsList: [],
      doctorsListCopy: [],
      slotsList: [],
      intervalIds: []
    }
  },
  computed: {
    ...mapGetters({
      activeTab: 'appointmentRequest/getActiveTab',
      showModal: 'appointmentRequest/getDoctorAssignModalHandler',
      selectedAppointment: 'appointmentRequest/getSelectedAppointment',
      role: 'configuration/getRole'
    })
  },
  methods: {
    searchDoctors: function () {
      let search = this.selectedDoctor.toLowerCase().replace(/\s+/g, '')
      if (search.length > 0) {
        this.doctorsList = this.doctorsListCopy.filter(function (obj) {
          let doctorName = obj.name.toLowerCase().replace(/\s+/g, '')
          if (doctorName.includes(search)) {
            return obj
          }
        })
      } else {
        this.doctorsList = this.doctorsListCopy
      }
    },
    toggleDropdown: function () {
      this.showOptions = !this.showOptions
    },
    selectTab: function (tab) {
      this.$store.dispatch('appointmentRequest/updateActiveTab', tab)
      this.fetchAppointment(tab)
    },
    selectDoctor: function (data) {
      this.slotsList = []
      this.selectedSlot = ''
      this.showSlots = false
      this.showOptions = false
      let selectedOrSearchDr = this.doctorsList.find(function (obj) {
        if (obj.doctor_id === data.doctor_id) {
          return obj || {}
        }
      })
      this.selectedDoctor = selectedOrSearchDr.name
      this.selectDoctorId = selectedOrSearchDr.doctor_id
      this.getSlots(selectedOrSearchDr)
    },
    selectSlot: function (slot) {
      this.selectedSlot = slot
    },
    groupedAppointments: function (data) {
      return data.reduce((acc, appointment) => {
        const date = appointment.date_string
        if (!acc[date]) {
          acc[date] = []
        }
        acc[date].push(appointment)
        return acc
      }, {})
    },
    getAppointments: function (tab) {
      appointments.fetch(tab, false, this.role).then(response => {
        if (response.status === 200) {
          this.data = this.role === 'externalAdmin' || this.role === 'specialistDoctor' ? this.groupedAppointments(response.body.appointment_requests) : response.body.appointment_requests
        } else {
          this.$toast.open({message: 'Something went wrong', type: 'error', position: 'top', queue: false})
        }
      }, response => {
        this.$toast.open({message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false})
      })
    },
    fetchAppointment: function (tab) {
      if ((tab === 'requested' && this.role === 'externalAdmin') || (tab === 'scheduled' && this.role === 'specialistDoctor')) {
        this.getAppointments(tab)
        const intervalId = setInterval(() => {
          this.getAppointments(tab)
        }, 20000)
        this.intervalIds.push(intervalId)
      } else if (tab !== 'requested') {
        this.intervalIds.forEach(intervalId => clearInterval(intervalId))
        this.intervalIds = []
        return this.getAppointments(tab)
      }
    },
    closeModal: function () {
      this.$store.dispatch('appointmentRequest/toggleAssignModal')
      this.showOptions = false
      this.showSlots = false
      this.selectedDoctor = ''
      this.doctorsList = this.doctorsListCopy
    },
    getDoctorList: function () {
      let obj = {id: this.selectedAppointment.id}
      appointments.doctorList(obj).then(response => {
        if (response.status === 200) {
          this.doctorsList = response.body.doctors
          this.doctorsListCopy = response.body.doctors
          if (this.selectedAppointment.doctor_id) {
            this.selectDoctor(this.selectedAppointment)
          }
        } else {
          this.$toast.open({message: 'Something went wrong', type: 'error', position: 'top', queue: false})
        }
      }, response => {
        this.$toast.open({message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false})
      })
    },
    getSlots: function (doctor) {
      let body = {
        provider_id: doctor.provider_id,
        booking_date: this.selectedAppointment.booking_date,
        benefit_type: 'specialist_consultation'
      }
      appointments.slotsList(body).then(response => {
        if (response.status === 200) {
          this.slotsList = response.body.slots
          this.showSlots = this.slotsList.length > 0
          !this.showSlots && this.$toast.open({message: 'Slots not found', type: 'warning', position: 'top', queue: false})
        } else {
          this.$toast.open({
            message: 'Something went wrong',
            type: 'error',
            position: 'top',
            queue: false
          })
        }
      }, response => {
        this.$toast.open({message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false})
        this.showSlots = false
      })
    },
    updateRemark: function (object) {
      let obj = {
        id: object.id,
        doctor_comments: object.remark
      }
      appointments.updateRemark(obj).then(response => {
        if (response.status === 200) {
          this.fetchAppointment(this.activeTab)
        } else {
        }
      }, response => {
      })
    },
    updateAppointmentStatus: function (payload) {
      appointments.spcApttSatusChange(payload).then(response => {
        this.fetchAppointment(this.activeTab)
        if (response.status === 200) {
          this.$toast.open({message: 'Status updated successfully', type: 'success', position: 'top', queue: false})
        } else {
          this.$toast.open({message: 'Something went wrong', type: 'error', position: 'top', queue: false})
        }
      }, response => {
        this.fetchAppointment(this.activeTab)
        this.$toast.open({message: response.data.message || 'Something went wrong', type: 'error', position: 'top', queue: false})
      })
    },
    updateStatus: function (object) {
      let updateStatusText = {
        confirmed: 'confirm',
        completed: 'complete',
        rejected: 'reject',
        incomplete: 'incomplete',
        scheduled: 'schedule'
      }
      let otherPayload = {id: object.id, status: object.status}
      let spcPayload = {id: object.id, status: updateStatusText[object.status]}
      if (this.role === 'specialistDoctor' || this.role === 'externalAdmin') {
        this.updateAppointmentStatus(spcPayload)
      } else {
        appointments.updateStatus(otherPayload).then(response => {
          if (response.status === 200) {
            this.fetchAppointment(this.activeTab)
          } else {
          }
        }, response => {
        })
      }
    },
    assignDoctorHandler: function () {
      if (this.selectedDoctor && this.selectedSlot) {
        let obj = {
          status: 'confirm',
          doctor_id: this.selectDoctorId,
          time: this.selectedSlot.utc_slot_time,
          id: this.selectedAppointment.id
        }
        this.updateAppointmentStatus(obj)
      } else {
        return
      }
      this.closeModal()
    },
    startConsultation: function (appointment) {
      this.$store.dispatch('configuration/setActiveMiniMenu', 'OfflineConsults')
      this.$store.dispatch('offlineConsultation/addAptConsultation', appointment)
    },
    uploadDocuments: function (fileList, appointment, key, category) {
      var formData = new FormData()
      let channelId = appointment.ek_id
      let consultId = appointment.consultation_id
      formData.append('customer_id', channelId)
      formData.append('consultation_id', consultId)
      formData.append('category', category)
      Array.prototype.forEach.call(fileList, function (file) {
        formData.append('files[]', file, file.name)
      })
      var V = this
      this.isLoading = true
      V.$http.post(window.API_URL + 'doctors/customer/documents', formData,
        {
          progress (e) {
            if (e.lengthComputable) {
              V.progress = e.loaded / e.total * 100
            }
          }
        }).then(response => {
          if (response.status === 200) {
            this.isLoading = false
            this.$toast.open({
              message: 'Uploaded successfully',
              type: 'success',
              position: 'bottom-right',
              queue: false
            })
          }

          let app = V.data[key].find(function (ele) {
            return (ele.consultation_id === appointment.consultation_id)
          })
          let index = V.data[key].indexOf(app)
          app.consultation_documents.unshift({name: response.body.name, id: response.body.id})
          if (index > -1) {
            V.data[key].splice(index, 1, app)
          }
        }).catch((error) => {
          console.log(error)
          this.isLoading = false
          this.$toast.open({
            message: 'Something went wrong',
            type: 'error',
            position: 'bottom-right',
            queue: false
          })
        })
    },
    updateAptRequest: function () {
      this.fetchAppointment(this.activeTab)
    }
  },
  mounted: function () {
    if (this.role === 'externalAdmin') {
      this.$store.dispatch('appointmentRequest/updateActiveTab', 'requested')
    }
    this.fetchAppointment(this.activeTab)
    this.$watch('showModal', function (newValue, oldValue) {
      if (newValue) {
        this.getDoctorList()
      }
    })
  }
}
</script>
<style scoped>
  .placeholder-icon::placeholder {
  font-family: ProximaNova;
  color:#4D6189;
  background-image: url('../../assets/search.svg');
  background-repeat: no-repeat;
  background-size: contain;
  padding-left: 20px;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
  -ms-overflow-style: none;
  scrollbar-width: none; 
}
</style>



// WEBPACK FOOTER //
// src/components/Appointments/Appointments.vue